<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.energystatisticselectmeteryear_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/energy/statistics/elect/meter/year/energystatisticselectmeteryear";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 350,
                    tip: false,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    column: [
                                                                                    {
                                    label: "主键",
                                    prop: "id",
                                    rules: [{
                                        required: true,
                                        message: "请输入主键",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "项目id",
                                    prop: "projectId",
                                    rules: [{
                                        required: true,
                                        message: "请输入项目id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "仪表id",
                                    prop: "meterId",
                                    rules: [{
                                        required: true,
                                        message: "请输入仪表id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "能耗量",
                                    prop: "statisticsNum",
                                    rules: [{
                                        required: true,
                                        message: "请输入能耗量",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "能耗周期起始时间",
                                    prop: "statisticsTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入能耗周期起始时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "能耗止码",
                                    prop: "endNum",
                                    rules: [{
                                        required: true,
                                        message: "请输入能耗止码",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "描述",
                                    prop: "description",
                                    rules: [{
                                        required: true,
                                        message: "请输入描述",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "备注",
                                    prop: "remark",
                                    rules: [{
                                        required: true,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.energystatisticselectmeteryear_add, false),
                    viewBtn: this.vaildData(this.permission.energystatisticselectmeteryear_view, false),
                    delBtn: this.vaildData(this.permission.energystatisticselectmeteryear_delete, false),
                    editBtn: this.vaildData(this.permission.energystatisticselectmeteryear_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
